import { Schema } from "effect";

export const RuntimeDependencyError = /* @__PURE__ */ (() => {
  class RuntimeDependencyError extends Schema.TaggedError<RuntimeDependencyError>()("RuntimeDependencyError", {
    dependency: Schema.Literals(["clock", "entropy", "digest"]),
    reason: Schema.Literals(["unavailable", "invalid-input", "invalid-output", "exhausted"]),
    message: Schema.tag("A runtime dependency could not complete the operation."),
    status: Schema.tag(500)
  }) {}
  return RuntimeDependencyError;
})();
export type RuntimeDependencyError = InstanceType<typeof RuntimeDependencyError>;
